import Vue from "vue"
import VueRouter from "vue-router"

Vue.use(VueRouter)
export const routes = [
  {
    path: "/",
    name: "homePage",
    component: () => import("@/views/HomePage/index.vue"),
    meta: {
      title: "首页",
      active: "homePage",
      hidden: false,
    },
  },
  {
    path: "/companyIntroduce",
    name: "companyIntroduce",
    component: () => import("@/views/AbouUs/CompanyIntroduce.vue"),
    meta: {
      title: "关于我们",
      active: "companyIntroduce",
      hidden: false,
    },
  },
  {
    path: "/LegalDetail",
    name: "LegalDetail",
    component: () => import("@/views/AbouUs/LegalDetail.vue"),
    meta: {
      title: "法律声明",
      active: "LegalDetail",
      hidden: false,
    },
  },
  {
    path: "/product",
    name: "product",
    component: () => import("@/views/ProductDevelopment/pipeline.vue"),
    meta: {
      title: "产品研发",
      active: "product",
      hidden: false,
    },
  },
  {
    path: "/technicalPlatform",
    name: "technicalPlatform",
    component: () => import("@/views/TechnicalPlatform/index.vue"),
    meta: {
      title: "技术平台",
      active: "technicalPlatform",
      hidden: false,
    },
  },
  {
    path: "/newsCenter",
    name: "newsCenter",
    component: () => import("@/views/NewsCenter/index.vue"),
    meta: {
      title: "新闻中心",
      active: "newsCenter",
      hidden: false,
    },
  },
  {
    path: "/newsDetail",
    name: "newsDetail",
    component: () => import("@/views/NewsCenter/detail.vue"),
    meta: {
      title: "新闻中心详情",
      active: "newsDetail",
      hidden: true,
    },
  },
  {
    path: "/industryNews",
    name: "industryNews",
    component: () => import("@/views/industryNews/index.vue"),
    meta: {
      title: "行业新闻",
      active: "industryNews",
      hidden: false,
    },
  },
  {
    path: "/industryDetail",
    name: "industryDetail",
    component: () => import("@/views/industryNews/detail.vue"),
    meta: {
      title: "行业新闻详情",
      active: "industryDetail",
      hidden: true,
    },
  },
  {
    path: "/process",
    name: "process",
    component: () => import("@/views/ProductDevelopment/process.vue"),
    meta: {
      title: "新闻中心",
      active: "process",
      hidden: false,
    },
  },
  {
    path: "/publication",
    name: "publication",
    component: () => import("@/views/ProductDevelopment/publication.vue"),
    meta: {
      title: "科研论文发表",
      active: "publication",
      hidden: false,
    },
  },
  {
    path: "/medicalService",
    name: "medicalService",
    component: () => import("@/views/MedicalService/index.vue"),
    meta: {
      title: "研究服务",
      active: "medicalService",
      hidden: false,
    },
  },
  {
    path: "/medicalDetail",
    name: "medicalDetail",
    component: () => import("@/views/MedicalService/detail.vue"),
    meta: {
      title: "研究服务详情",
      active: "medicalDetail",
      hidden: true,
    },
  },
  {
    path: "/contractUs",
    name: "contractUs",
    component: () => import("@/views/ContractUs/index.vue"),
    meta: {
      title: "联系我们",
      active: "contractUs",
      hidden: false,
    },
  },
  {
    path: "/talentRecruitment",
    name: "talentRecruitment",
    component: () => import("@/views/TalentRecruitment/index.vue"),
    meta: {
      title: "人才招聘",
      active: "talentRecruitment",
      hidden: false,
    },
  },
  // {
  //   path: "/newsDetail",
  //   name: "newsDetail",
  //   component: () => import("@/views/NewsCenter/detail.vue"),
  //   meta: {
  //     title: "新闻中心详情",
  //     active: "newsDetail",
  //     hidden: true,
  //   },
  // },


]
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}
const createRouter = () =>
  new VueRouter({
    mode: "history",
    scrollBehavior: () => ({ x: 0, y: 0 }),
    routes: routes,
  })

const router = createRouter()
export default router
